import VideoMeetingRoleAndDescription from "./VideoMeetingRoleAndDescription";
import type { MeetingDetails } from "@core/features/videoMeeting";

type Props = {
  meetingDetails: MeetingDetails;
};

export function VideoMeetingRoleAndDescriptionContainer({ meetingDetails }: Props) {
  const participantRole = meetingDetails.user_participation?.role?.name;

  const participantRoleDescription =
    meetingDetails.user_participation?.role?.description;

  if (!participantRole) {
    return null;
  }

  return (
    <VideoMeetingRoleAndDescription
      participantRole={participantRole}
      participantRoleDescription={participantRoleDescription}
    />
  );
}

export default VideoMeetingRoleAndDescriptionContainer;
